import { system_function } from './templates';

export default {
	system_function: { ...system_function },
	system_functions: []
};
